import { render, staticRenderFns } from "./CreateDomaineFromList.vue?vue&type=template&id=277a9dda&"
import script from "./CreateDomaineFromList.vue?vue&type=script&lang=js&"
export * from "./CreateDomaineFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports